export default __webpack_public_path__ + "static/media/orange-alert.e0f38a08.svg";